<div class="container-pagination">
  <ul>
    <li>
      <button type="button" class="btn btn-outline" title="Primeira Pagina" [disabled]="1 === page" (click)="goToPage(1)">
        <span class="material-symbols-outlined">keyboard_double_arrow_left</span>
      </button>
    </li>
    <li>
      <button type="button" class="btn btn-outline" title="Pagina Anterior" [disabled]="page === 1" (click)="goToPage(page - 1)">
        <span class="material-symbols-outlined">chevron_left</span>
      </button>
    </li>

    <li *ngIf="page > 1">
      <button type="button" class="btn btn-primary btn-outline" (click)="goToPage(page - 1)">
        {{ page - 1 }}
      </button>
    </li>

    <li>
      <button type="button" class="btn btn-primary" (click)="goToPage(page)">
        {{ page }}
      </button>
    </li>

    <li *ngIf="page < total">
      <button type="button" class="btn btn-primary btn-outline" (click)="goToPage(page + 1)">
        {{ page + 1 }}
      </button>
    </li>

    <li>
      <button type="button" class="btn btn-outline" title="Próxima Pagina" [disabled]="page === total" (click)="goToPage(page + 1)">
        <span class="material-symbols-outlined">chevron_right</span>
      </button>
    </li>

    <li>
      <button type="button" class="btn btn-outline" title="Ultima Pagina" [disabled]="page === total" (click)="goToPage(total)">
        <span class="material-symbols-outlined">keyboard_double_arrow_right</span>
      </button>
    </li>
  </ul>
</div>
